import GameUtil from "../../../../../utility/game_util";

const {ccclass, property} = cc._decorator;

@ccclass
export class InsideTaskItem extends cc.Component {
    @property(cc.Node)
    awardBtn:cc.Node = null;

    @property(cc.Label)
    content:cc.Label = null;

    @property(cc.Label)
    round:cc.Label = null;

    @property(cc.Label)
    awardnumb:cc.Label = null;


    refreshItem(data:any,func?:Function){
        this.reset();
   
        this.awardBtn.on('click', function(){
            func && func(data);
        }, this)

        this.updateTitle(data.taskContent);
        this.updateAwardNumb(data.awardAccountVal);

        cc.log('xxxxx',data.currentConditionVal,data.conditionVal);

        this.updateCnt(true,data.isFinish,data.currentConditionVal,data.conditionVal);
        this.updateBtnState(data.isFinish,data.isReceive)
    }

    protected updateAwardNumb(number:number){
        let cnt = GameUtil.currencyFormatting(number,0)
        this.awardnumb.string = 'x'+ cnt;
    }

    protected updateTitle(content:string){
        this.content.string = content;
    }

    protected updateCnt(isShow:boolean,isFinish?:boolean,cur?:string,total?:string){
        this.round.node.active = isShow;
        if (isShow) {
            cur = GameUtil.currencyFormatting(Number(cur),0)
            total = GameUtil.currencyFormatting(Number(total),0)
            this.round.string = '{0}/{1}'.format(cur,total);
            this.round.node.color = isFinish ? new cc.Color(24,161,0,255):new cc.Color(237,26,21,255);
        }
    }

    protected updateBtnState(isFinish:boolean,isReceive:boolean){
        let isCanReceive = isFinish && !isReceive;
        this.awardBtn.active = isCanReceive;//是否领取 false 没有领取
        if (isCanReceive) {
            this.updateCnt(false);
        }
    }

    reset(){
        this.awardBtn.targetOff(this);
    }
}
